import * as React from "react";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { grey } from "@mui/material/colors";
import FavoriteIcon from "@mui/icons-material/Favorite";
import EmailIcon from "@mui/icons-material/Email";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import parse from "html-react-parser";
import MailDialogs from "../../elements/send_mail/send_mail";
import { useSelector, useDispatch } from "react-redux";
import { setEmailShow, setEmailHide } from "../../store/emailSelector";
import cover from "./nofoto.jpg";
import { API_MEDIA, ApiUrlStatic } from "../../env";

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme }) => ({
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
  variants: [
    {
      props: ({ expand }) => !expand,
      style: {
        transform: "rotate(0deg)",
      },
    },
    {
      props: ({ expand }) => !!expand,
      style: {
        transform: "rotate(180deg)",
      },
    },
  ],
}));

export default function RecipeReviewCard({
  title,
  description,
  image,
  subheader,
  email,
  tel,
  status,
  forEmail,
}) {
  const Card_ = styled(Card)(({ theme }) => ({
    backgroundColor: theme.color.main,
    padding: theme.spacing(0),
    textAlign: "left",
    color: theme.color.secondary,
    // width: "250px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    [theme.breakpoints.up("sm")]: {
      width: "100%",
    },
  }));

  const dispatch = useDispatch();
  const emailShow = useSelector((state) => state.emailSelector.email);
  const [expanded, setExpanded] = React.useState(false);
  // const [open, setOpen] = React.useState(emailShow);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  console.log(`${ApiUrlStatic}${cover}`);
  console.log("тут имаге");
  console.log(image);
  // console.log(image);

  return (
    <>
      {emailShow && <MailDialogs />}

      <Card_>
        <CardHeader
          avatar={
            <Avatar sx={{ bgcolor: grey[400] }} aria-label="recipe">
              {status}
            </Avatar>
          }
          title={title}
          subheader={subheader}
        />
        <CardMedia
          component="img"
          height="194"
          image={
            image && image != "null"
              ? `${API_MEDIA}${image}`
              : `${ApiUrlStatic}${cover}`
          }
          alt={title}
        />
        <CardContent>
          {tel && tel != "null" ? (
            <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
              <b>Телефон-</b> {tel}
            </Typography>
          ) : (
            <></>
          )}
          {email && email != "null" ? (
            <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
              <b>Электронная почта-</b> {email}
            </Typography>
          ) : (
            <></>
          )}
        </CardContent>
        <CardActions disableSpacing>
          <IconButton
            aria-label="написать"
            onClick={() => {
              dispatch(setEmailShow([forEmail, email]));
              // console.log(email);
            }}
          >
            <EmailIcon />
          </IconButton>
          {/* <IconButton aria-label="share">
          <ShareIcon />
        </IconButton> */}
          {description && description != "null" ? (
            <ExpandMore
              expand={expanded}
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more"
            >
              <ExpandMoreIcon />
            </ExpandMore>
          ) : (
            <></>
          )}
        </CardActions>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <Typography variant="body2" sx={{ marginBottom: 2 }}>
              {parse(description)}
            </Typography>
          </CardContent>
        </Collapse>
      </Card_>
    </>
  );
}
